import React from 'react';
import PropTypes from 'prop-types';

import isNotEmptyReactElementContent from 'core/utils/content';

import styles from './index.styl';

/**
 * @author Anton Ignatov <a.ignatov@rambler-co.ru>
 */
export default function Checkable(props) {
  const {
    gap,
    children,
    icon: Icon,
    width,
    height,
    ...inputProps
  } = props;

  return (
    <label className={styles.control}>
      <input
        {...inputProps}
        className={Icon && styles.input}
      />
      {Icon && (
        <Icon
          className={styles.icon}
          width={width}
          height={height}
        />
      )}
      {isNotEmptyReactElementContent(children) && (
        <span
          className={styles.content}
          {...gap && { style: { paddingLeft: gap } }}
        >
          {children}
        </span>
      )}
    </label>
  );
}

Checkable.defaultProps = {
  width: '24px',
  height: '24px',
};

Checkable.propTypes = {
  /**
   * Отступ от иконки до содержимого
   */
  gap: PropTypes.string,

  /**
   * Компонент иконки
   */
  icon: PropTypes.func,

  /**
   * Тип checkable-элемента
   */
  type: PropTypes.oneOf([
    'radio',
    'checkbox',
  ]).isRequired,

  /**
   * Ширина иконки, заданная в пикселях
   */
  width: PropTypes.string,

  /**
   * Высота иконки, заданная в пикселях
   */
  height: PropTypes.string,

  /**
   * Контент инпута, который будет отрендерен компонентом
   */
  children: PropTypes.node,
};
